module.exports = __webpack_public_path__ + "ui-static/img/cards-no-items_dark.28cad1f6.svg";